// 将downPopup.vue注册为全局方法弹框
import downPopup from './downPopup.vue'
import Vue from 'vue'
let DownPopup
const initDownPopup = () => {
  const ShareConstructor = Vue.extend(downPopup)
  DownPopup = new ShareConstructor({
    el: document.createElement('div')
  })
  document.body.appendChild(DownPopup.$el)
}

const downPopupMethods = (data)=> {
    if (!DownPopup) {
      initDownPopup()
    }
    DownPopup.isshow = true
    DownPopup.type = data
}

Vue.prototype.$downPopup = downPopupMethods
export default downPopupMethods